import { announcementsConstants } from "../constants/announcementsConstants";

const initialState = {
  sending: false,
  announcementsResponse: {},
  announcementsList: {},
  status: {},
  detail: {},
  error: {},
};

export default function announcementsReducer(state = initialState, action) {
  switch (action.type) {
    case announcementsConstants.GET_ANNOUNCEMENTS_REQUEST:
      return {
        sending: true
      };
    case announcementsConstants.GET_ANNOUNCEMENTS_SUCCESS:
      return {
        ...state,
        announcementsList: action.data
      };
    case announcementsConstants.GET_ANNOUNCEMENTS_FAILURE:
      return {
        ...state,
        error: action.error
      };   
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/announcementsReducer.js